import React from "react";
import PropTypes from "prop-types";
import { Message } from "semantic-ui-react";

// Constants for message configurations
const MESSAGE_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
  SUBMITTING: "submitting",
};

const MESSAGE_CONFIGS = {
  [MESSAGE_TYPES.ERROR]: {
    type: "negative",
    defaultHeader: "Registration Error",
    defaultContent: "",
  },
  [MESSAGE_TYPES.SUCCESS]: {
    type: "positive",
    defaultHeader: "Success!",
    defaultContent: "",
  },
  [MESSAGE_TYPES.SUBMITTING]: {
    type: "info",
    defaultHeader: "Creating Account...",
    defaultContent: "Please wait while we create your account.",
  },
};

const SignupMessages = ({
  hasError,
  errorHeader,
  errorMessage,
  hasSuccess,
  successMessage,
  isSubmitting,
}) => {
  // Helper function to render a message based on condition and config
  const renderMessage = (
    condition,
    messageType,
    customHeader,
    customContent
  ) => {
    if (!condition) return null;

    const config = MESSAGE_CONFIGS[messageType];
    const messageProps = {
      [config.type]: true,
      header: customHeader || config.defaultHeader,
      content: customContent || config.defaultContent,
    };

    return <Message {...messageProps} />;
  };

  return (
    <>
      {renderMessage(hasError, MESSAGE_TYPES.ERROR, errorHeader, errorMessage)}
      {renderMessage(hasSuccess, MESSAGE_TYPES.SUCCESS, null, successMessage)}
      {renderMessage(isSubmitting, MESSAGE_TYPES.SUBMITTING)}
    </>
  );
};

SignupMessages.propTypes = {
  hasError: PropTypes.bool,
  errorHeader: PropTypes.string,
  errorMessage: PropTypes.string,
  hasSuccess: PropTypes.bool,
  successMessage: PropTypes.string,
  isSubmitting: PropTypes.bool,
};

SignupMessages.defaultProps = {
  hasError: false,
  errorHeader: MESSAGE_CONFIGS[MESSAGE_TYPES.ERROR].defaultHeader,
  errorMessage: MESSAGE_CONFIGS[MESSAGE_TYPES.ERROR].defaultContent,
  hasSuccess: false,
  successMessage: MESSAGE_CONFIGS[MESSAGE_TYPES.SUCCESS].defaultContent,
  isSubmitting: false,
};

export default SignupMessages;
